import { useRef, useState } from 'react';

import { CUSTOM_AMOUNT_VALIDATION_STATUS } from '../Utils/customAmountValidationStatus';
import { PaymentScreenTypes } from '../Utils/PaymentTypes';
import { TOPUP_TAB_TYPES } from '../Utils/topUpTabTypes';

const regexCheck = customAmountMaximumParam => {
  return new RegExp(
    `^[1-9][0-9]{0,${parseInt(customAmountMaximumParam, 10) > 0 ? `${customAmountMaximumParam}`.length - 1 : 0
    }}$`,
  );
};

function useCustomAmount({ setStatus, customAmountMaximum }) {
  const regexExpression = useRef(regexCheck(customAmountMaximum)).current;

  const [selectedTab, setSelectedTab] = useState(null);
  const [customAmountValidation, setCustomAmountValidation] = useState(
    CUSTOM_AMOUNT_VALIDATION_STATUS.REGEX_ERROR,
  );
  const [customAmount, setCustomAmount] = useState('');

  const onSelectTabChange = tabType => {
    setSelectedTab(tabType);
    if (tabType === TOPUP_TAB_TYPES.DEFAULT_TOPUP) {
      setCustomAmountValidation(CUSTOM_AMOUNT_VALIDATION_STATUS.VALID);
      setStatus(PaymentScreenTypes.DEFAULT);
    } else if (tabType === TOPUP_TAB_TYPES.CUSTOM_AMOUNT_TOPUP) {
      setCustomAmountValidation(
        validateCustomAmount(customAmount, regexExpression, customAmountMaximum),
      );
      setStatus(PaymentScreenTypes.CUSTOM_AMOUNT);
    }
  };

  const validateCustomAmount = (amount, customAmountRegex, customAmountMaximumParam) => {
    if (parseInt(amount) > parseInt(customAmountMaximumParam)) {
      return CUSTOM_AMOUNT_VALIDATION_STATUS.REGEX_ERROR;
    } else if (!customAmountRegex.test(amount)) {
      return CUSTOM_AMOUNT_VALIDATION_STATUS.REGEX_ERROR
    }
    else if (parseInt(amount, 10) > parseInt(customAmountMaximumParam, 10)) {
      return CUSTOM_AMOUNT_VALIDATION_STATUS.MAX_ERROR;
    } else {
      return CUSTOM_AMOUNT_VALIDATION_STATUS.VALID;
    }
  };
  const onChangeCustomAmount = amount => {
    setCustomAmount(amount);
    setCustomAmountValidation(validateCustomAmount(amount, regexExpression, customAmountMaximum));
  };

  return {
    selectedTab,
    onSelectTabChange,
    customAmountValidation,
    customAmount,
    onChangeCustomAmount,
    validateCustomAmount,
  };
}
export { regexCheck };
export default useCustomAmount;
